import React, { useEffect } from "react";
import { Box, Button, Stack, Typography, CircularProgress } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { ReactComponent as Logo } from "../../vendor/logo.svg";
import { LockOutlined } from "@mui/icons-material";
import colors from "../../utils/colors";

function Page403() {
  const [URLSearchParams] = useSearchParams();
  const error_description = URLSearchParams.get("error_description");
  
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  const hasPermissionError = !!error_description;

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !hasPermissionError) {
      loginWithRedirect({
        appState: { returnTo: "/v2/overview" },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, hasPermissionError]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundColor: "#fff",
        }}
      >
        <CircularProgress sx={{ color: colors.primary[300] }} />
      </Box>
    );
  }

  if (!isAuthenticated && !hasPermissionError) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          backgroundColor: "#fff",
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: colors.neutral[700],
          }}
        >
          Redirecting to login...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >
      <Stack
        alignItems="center"
        spacing={4}
        sx={{
          maxWidth: 400,
          textAlign: "center",
          p: 6,
        }}
      >
        <Logo style={{ width: 180, height: 44 }} />
        
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: colors.primary[100],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LockOutlined
            sx={{
              fontSize: 40,
              color: colors.primary[300],
            }}
          />
        </Box>

        <Stack spacing={2}>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 600,
              lineHeight: "36px",
              color: colors.neutral[1000],
            }}
          >
            Access Denied
          </Typography>
          
          <Typography
            sx={{
              fontSize: 14,
              lineHeight: "21px",
              color: colors.neutral[700],
            }}
          >
            {error_description || "You don't have permission to access this resource. Please contact your administrator if you believe this is an error."}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            onClick={() => window.history.back()}
            sx={{
              height: 36,
              borderRadius: "8px",
              fontSize: 14,
              textTransform: "none",
              borderColor: colors.neutral[300],
              color: colors.neutral[700],
              "&:hover": {
                borderColor: colors.neutral[500],
                backgroundColor: colors.neutral[50],
              },
            }}
          >
            Go Back
          </Button>
          
          <Button
            variant="contained"
            href="/v2/overview"
            sx={{
              height: 36,
              borderRadius: "8px",
              fontSize: 14,
              textTransform: "none",
              backgroundColor: colors.primary[300],
              "&:hover": {
                backgroundColor: "#07f",
              },
            }}
          >
            Go to Dashboard
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Page403;
